import React, { useMemo } from 'react';
import { playSuccessSound, playFailureSound } from '../utils/materialUtils';

const getCorrectWordForm = (count) => {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) return 'вариант';
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return 'варианта';
  return 'вариантов';
};

const CheckboxExercise = ({
  segment,
  selectedIds = [],
  itemStatus = {},
  status = null,
  onSelectionChange,
  silent = false,
  readOnly = false,
}) => {
  const options = useMemo(() => segment.options || [], [segment.options]);

  const correctIds = useMemo(
    () => options.filter((option) => option.correct).map((option) => option.id),
    [options]
  );

  const selectedSet = useMemo(() => new Set(selectedIds), [selectedIds]);
  const isComplete = status === 'complete' || readOnly;

  const isSelectionComplete = (nextSelected) => {
    const selected = [...nextSelected];
    const allCorrectSelected = correctIds.every((id) => nextSelected.has(id));
    const noWrongSelected = selected.every(
      (id) => options.find((option) => option.id === id)?.correct
    );
    return allCorrectSelected && noWrongSelected && correctIds.length > 0;
  };

  const toggleOption = (optionId) => {
    if (isComplete || readOnly) return;

    const option = options.find((item) => item.id === optionId);
    if (!option) return;

    if (selectedSet.has(optionId)) {
      if (itemStatus[optionId] === 'correct') return;

      const nextSelected = selectedIds.filter((id) => id !== optionId);
      const nextItemStatus = { ...itemStatus };
      delete nextItemStatus[optionId];
      onSelectionChange(nextSelected, nextItemStatus, status);
      return;
    }

    const nextSelected = [...selectedIds, optionId];
    const nextStatus = option.correct ? 'correct' : 'incorrect';
    const nextItemStatus = { ...itemStatus, [optionId]: nextStatus };

    if (option.correct) {
      if (!silent) playSuccessSound();
    } else if (!silent) {
      playFailureSound();
    }

    const nextComplete = isSelectionComplete(new Set(nextSelected));
    onSelectionChange(
      nextSelected,
      nextItemStatus,
      nextComplete ? 'complete' : status
    );
  };

  return (
    <div className={`checkbox-exercise ${isComplete ? 'complete' : ''}`}>
      <p className="checkbox-exercise-prompt">
        Выберите {correctIds.length} правильных {getCorrectWordForm(correctIds.length)}:
      </p>
      <ul className="checkbox-options">
        {options.map((option) => {
          const optionStatus = itemStatus[option.id];
          const isSelected = selectedSet.has(option.id);

          return (
            <li key={option.id}>
              <button
                type="button"
                className={`checkbox-option ${optionStatus || ''} ${isSelected ? 'selected' : ''}`}
                onClick={() => toggleOption(option.id)}
                disabled={isComplete || readOnly || optionStatus === 'correct'}
              >
                <span className="checkbox-box" aria-hidden="true">
                  {isSelected && optionStatus === 'correct' && '✓'}
                  {isSelected && optionStatus === 'incorrect' && '✓'}
                </span>
                <span className="checkbox-label">{option.text}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CheckboxExercise;
